export default __webpack_public_path__ + "static/media/b6.d50d57cf.svg";